import * as angular from "angular";
import {IController} from "angular";
import * as _ from 'lodash';

export class PlanningVehicleResourcesSelectionTableCtrl implements IController {

  resources: any;
  selectedIds: any;
  onSelect: Function;
  onRemove: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.selectedIds) {
      this.selectedIds = [];
    }

  }

  //////////////////////////////////////////////////////////////////////////

  isSelectedResource(resource) {
    return _.indexOf(this.selectedIds, resource.vehicleId) !== -1;
  }

  // not used locally or at the template so deleted
  // onUnlimitedChanged(resource, isUnlimited) {
  //   const resourceRef = _.find(this.resources, (r) => {
  //     return r.vehicleId === resource.vehicleId;
  //   });
  //   if (resourceRef) {
  //     resourceRef.amount = isUnlimited ? undefined : 1;
  //   }
  // }
}

angular
  .module('bringoz.admin.planning')
  .component('planningVehicleResourcesSelectionTable', {
    bindings: {
      resources: '<',
      selectedIds: '<?',
      onSelect: '&',
      onRemove: '&'
    },
    template: require('./planning-vehicle-resources-selection-table.html').default,
    controller: PlanningVehicleResourcesSelectionTableCtrl
  });
